import { useQuery } from '@apollo/client';
import { Application } from '@bybeam/platform-types';
import Loading from '@platform-ui-common/components/Loading/index.js';
import GetUserApplicationsQuery from '@platform-ui/application/graphql/GetUserApplications.graphql';
import React, { ReactNode, useContext } from 'react';
import { ApplicantLayout } from '../components/index.js';
import { ErrorScreen } from '../pages/index.js';

export const UserApplicationsContext = React.createContext<Application[]>([]);

export function UserApplicationsProvider({ children }: { children: ReactNode }): JSX.Element {
  const { data, loading, error } = useQuery<{ applications: { applications: Application[] } }>(
    GetUserApplicationsQuery,
  );

  const applications = data?.applications.applications ?? [];
  if (loading) return <Loading size="XXL" fullPage />;
  if (error)
    return (
      <ApplicantLayout>
        <ErrorScreen />
      </ApplicantLayout>
    );
  return (
    <UserApplicationsContext.Provider value={applications}>
      {children}
    </UserApplicationsContext.Provider>
  );
}

export default function useUserApplications(): Application[] {
  return useContext(UserApplicationsContext);
}
